// Papertrade session-key onboarding: pure helpers. The error strings below are
// the backend's (services/public-api/src/papertrade_onboarding.rs) and are the
// only signal confirm gives for what the customer can do next.

export type ConfirmErrorClass = 'retry' | 'restart' | 'fatal'

/** Backend PENDING_TTL_SECONDS: how long a prepared registration stays signable. */
export const PREPARE_WINDOW_MS = 600_000

/**
 * retry: confirm again with the same signature. restart: the pending
 * registration is gone, prepare and sign again. fatal: surface the message.
 */
export function classifyConfirmError(message: string): ConfirmErrorClass {
  if (
    message.endsWith('retry confirm in a moment') ||
    message === 'Failed to activate the account'
  ) {
    return 'retry'
  }
  // 'Papertrade is unreachable' exactly is the prepare-side error.
  if (message.endsWith('start again') || message === 'Papertrade is unreachable') {
    return 'restart'
  }
  return 'fatal'
}

/** A missing response may hide a successful registration: retain the signature for retry. */
export function isRetryableConfirmError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const e = error as {
    transient?: boolean
    isAxiosError?: boolean
    status?: number
    response?: { status?: number }
  }
  if (e.transient || (e.isAxiosError && !e.response)) return true
  const status = e.response?.status ?? e.status
  return status === 408 || status === 429 || (status !== undefined && status >= 500)
}

/** EIP-1193 user rejection. */
export function isUserRejection(e: unknown): boolean {
  return (e as { code?: unknown } | null)?.code === 4001
}
